import { render, staticRenderFns } from "./MultipleCoupons.vue?vue&type=template&id=72cab04e&scoped=true"
import script from "./MultipleCoupons.vue?vue&type=script&lang=js"
export * from "./MultipleCoupons.vue?vue&type=script&lang=js"
import style0 from "./MultipleCoupons.vue?vue&type=style&index=0&id=72cab04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cab04e",
  null
  
)

export default component.exports